import React from 'react';

import Icon from '../common/Icon';

const AUTH_FEATURES = [
  'Live transcription',
  'Multilingual translation',
  'AI-powered answers',
];

export function AuthBrandMark({ className = '' }) {
  return (
    <div className={`auth-brand ${className}`.trim()}>
      <div className="auth-brand-title">
        <Icon name="waveform" size={24} />
        <span>KrishvaQ</span>
      </div>
      <div className="auth-brand-subtitle">AI Meeting Assistant</div>
    </div>
  );
}

function AuthBrandPanel() {
  return (
    <aside className="auth-side-panel">
      <AuthBrandMark />

      <div className="auth-side-copy">
        <h1>Your meeting intelligence workspace.</h1>
        <p>Sign in to capture conversations, surface decisions and keep follow-ups organized with KrishvaQ.</p>
      </div>

      <div className="auth-feature-list">
        {AUTH_FEATURES.map((feature) => (
          <span key={feature}>
            <Icon name="check" size={18} />
            {feature}
          </span>
        ))}
      </div>
    </aside>
  );
}

export default AuthBrandPanel;
